<template>
  <div>
    <template v-if="selectedEffect === 'outerGlow'">
      <OuterGlowEffect
        :target="target"
      />
    </template>
  </div>
</template>

<script>



import OuterGlowEffect from "@frontend/components/modules/layouts-page/EditorControl/components/OuterGlowEffect.vue";

export default {
  name: 'EffectsModule',
  components: {OuterGlowEffect},
  props: {
    target: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    selectedEffect: 'outerGlow',
  })
};
</script>

<style scoped lang="scss">

</style>
